import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'flo-value-prop',
  templateUrl: './value-prop.component.html',
  styleUrls: ['./value-prop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValuePropComponent {
  @Input()
  proposition: string
  @Input()
  label: string
  @Input()
  svgLabel = true
  @Input()
  svgWidth = '24'

  public get isSingleClickPlans(): boolean {
    return this.label === 'single-click-plans'
  }

  public get isCheckmarkPrimary(): boolean {
    return this.label === 'checkmark-primary'
  }
}
